import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { ProductIcon } from "@/components/ProductIcon";
import { getFeaturedProducts } from "@/data/catalog";
import { buildStockWhatsAppUrl } from "@/lib/whatsapp";

export function HeroSection() {
  const tiles = getFeaturedProducts(9);
  const waUrl = buildStockWhatsAppUrl();

  return (
    <section className="relative overflow-hidden border-b border-nm-border">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-nm-red/20 blur-[110px]"
      />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-12 sm:px-6 md:py-20 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-6">
          <span className="inline-flex items-center rounded-full border border-nm-red/30 bg-nm-red/10 px-3 py-1 text-xs font-semibold text-nm-glow">
            Langganan digital jadi lebih praktis
          </span>
          <h1 className="mt-4 text-3xl font-extrabold leading-tight text-nm-text sm:text-4xl lg:text-5xl">
            Subscription Digital Favoritmu,{" "}
            <span className="text-nm-red">Lebih Mudah Dibeli</span>
          </h1>
          <p className="mt-4 max-w-xl text-base text-nm-muted sm:text-lg">
            Pilih produk, tentukan durasi, lihat harga, lalu selesaikan pesanan
            melalui WhatsApp.
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/produk"
              data-testid="hero-cta-primary"
              className="inline-flex h-12 items-center justify-center gap-2 rounded-lg bg-nm-red px-6 font-semibold text-white shadow-lg shadow-nm-red/25 transition-all duration-200 hover:bg-nm-red-hover active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nm-red focus-visible:ring-offset-2 focus-visible:ring-offset-nm-bg"
            >
              Lihat Semua Produk
              <ArrowRight className="h-4 w-4" />
            </Link>
            <a
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="inline-flex h-12 items-center justify-center gap-2 rounded-lg border border-nm-border bg-nm-surface px-6 font-semibold text-nm-text transition-colors hover:border-wa/50 hover:text-wa"
            >
              <MessageCircle className="h-4 w-4" />
              Cek Stok via WhatsApp
            </a>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="mx-auto grid max-w-md grid-cols-3 gap-3 sm:gap-4">
            {tiles.map((product, i) => (
              <Link
                key={product.slug}
                to={`/produk/${product.slug}`}
                aria-label={product.name}
                className={`group rounded-2xl border border-nm-border bg-nm-surface p-3 transition-all duration-200 hover:-translate-y-1 hover:border-nm-red/40 ${
                  i % 2 === 0 ? "sm:translate-y-2" : ""
                }`}
              >
                <ProductIcon
                  product={product}
                  className="aspect-square w-full"
                  rounded="rounded-xl"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
